
/**
 * @about app js file contains routing of app
 * routing app
 * react-router-dom
 */
// react lib
import React, { Component } from 'react';
// roucting lib
import {
    Router,
    Route,
    Switch,
    Redirect
} from 'react-router-dom';

import SiteMediaList from "./SiteMediaList"
import MediaData from "./SiteMediaImport";

class ResourceList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <Switch>
                <Route exact path={`/sites/edit/:folderId/:id/media`} component={SiteMediaList} />
                <Route exact path={`/sites/edit/:folderId/:id/media/data`} component={MediaData} />
            </Switch>
        );

    }
}

export default ResourceList;

